import React from 'react';
import MasterButton from '../../../general_components/MasterButton/MasterButton.js';
import { logMonthlyLinkClicked } from '../../../../utils/monthlyGiftAnalytics';

import recurring_gift_green_bg from '../../../../images/illustrations/recurring_gift_green_bg_100.png';
import monthly_gift_no_bg from '../../../../images/illustrations/monthly_gift_no_bg.png';

/**
 * registry page "Start a Monthly Gift" CTA card.
 *
 * Renders twice on the gifting page (once with variant='desktop' inside the left
 * column, once with variant='mobile' inside the right column at the top). 
 *
 *
 * Props:
 * - variant: 'desktop' | 'mobile'
 * - account_name: child's display name (used in copy + button text)
 * - monthly_link: deep link into the give-a-gift flow with frequency=monthly preselected
 * - matching_available: when true, render the "2x" badge overlapping the CTA
 *   (same pattern as the main goals card CTA — semantically tied to active matching)
 * - remember_goals: optional callback fired before navigation so currently-selected
 *   goal chips carry into the gifting flow (matches the existing "Give a gift" CTAs)
 */
class Monthly_gift_entry_card extends React.Component {
    constructor(props) {
        super(props);
        this.handleCtaClick = this.handleCtaClick.bind(this);
    }

    handleCtaClick() {
        // Always fire the click event so analytics can distinguish desktop vs mobile interactions
        // even though the impression event is deduped on the parent side.
        logMonthlyLinkClicked({
            source: 'public registry card',
            variant: this.props.variant,
        });
        if (typeof this.props.remember_goals === 'function') {
            this.props.remember_goals();
        }
    }

    // CTA label JSX with refresh icon: icon shows before the text
    renderCtaLabel(safe_name) {
        return (
            <>
                <i className='material-icons monthly_gift_cta_icon'>refresh</i>
                <span>Start a Monthly Gift for {safe_name}</span>
            </>
        );
    }

    render() {
        const { variant, account_name, monthly_link, matching_available } = this.props;
        const safe_name = (account_name || 'them').trim() || 'them';

        // ----- Desktop variant -----
        if (variant === 'desktop') {
            return (
                <div className='monthly_gift_card_desktop desktop_only'>
                    <img
                        src={recurring_gift_green_bg}
                        alt=''
                        className='monthly_gift_card_desktop_illustration'
                    />
                    <div className='monthly_gift_card_desktop_content'>
                        <h3 className='monthly_gift_card_title no_margin'>Give Monthly Gifts</h3>
                        <p className='monthly_gift_card_body no_margin'>
                            Set up an automatic monthly gift for {safe_name}'s future.
                        </p>
                        {/* CTA wrapper provides position:relative for the absolute-positioned 2x badge */}
                        <div className='gifting_page_cta_with_badge'>
                            <MasterButton
                                buttonText={this.renderCtaLabel(safe_name)}
                                notSticky={true}
                                handleButtonClick={this.handleCtaClick}
                                links={true}
                                linkTo={monthly_link}
                                icon=''
                            />
                            {matching_available ? <span className='matching_2x_badge'>2x</span> : null}
                        </div>
                    </div>
                </div>
            );
        }

        // ----- Mobile variant -----
        return (
            <div className='monthly_gift_card_mobile mobile_only'>
                <img
                    src={monthly_gift_no_bg}
                    alt=''
                    className='monthly_gift_card_mobile_illustration'
                />
                <h2 className='monthly_gift_card_title'>Start a Monthly Gift</h2>
                <p className='monthly_gift_card_body'>
                    Set up an automatic monthly gift for {safe_name}'s future. Perfect for close family who want to give regularly over time.
                </p>
                {/* CTA wrapper provides position:relative for the absolute-positioned 2x badge */}
                <div className='gifting_page_cta_with_badge'>
                    <MasterButton
                        buttonText={this.renderCtaLabel(safe_name)}
                        notSticky={true}
                        handleButtonClick={this.handleCtaClick}
                        links={true}
                        linkTo={monthly_link}
                        icon=''
                    />
                    {matching_available ? <span className='matching_2x_badge'>2x</span> : null}
                </div>
            </div>
        );
    }
}

export default Monthly_gift_entry_card;
